import './birthday-reward.scss';

import { Outlet } from "react-router-dom";

import { FilterBirthdayRewardProvider } from "./filter-birthday-reward/filter-birthday-reward.context";

export function BirthdayReward() {
  return (
    <div id="ShellBirthdayReward" className="birthday-reward">
       <FilterBirthdayRewardProvider>
        <Outlet />
      </FilterBirthdayRewardProvider>
    </div>
  );
}

export default BirthdayReward;
